import {
  AutomationBlock,
  WorkflowFlowTypes,
  WorkflowNotificationStates,
  WorkflowNotificationStatesLable,
  WorkflowFormData,
  WorkflowStateNotificationTypes,
  WorkflowStateNotificationsFormData,
  TagColor,
  WorkflowUARFormData,
  WorkflowAttestationTypes
} from './types'
import { WORKFLOW_DEFAULT_CRON, WorkflowBlockType } from '../../workflowsSlice'
import SvgActions from '../../../../assets/inlineSvg/icon-shield-with-hammer.svg'
import SvgRuleSets from '../../../../assets/inlineSvg/icon-shield-in-square.svg'
import SvgAlertAssignment from '../../../../assets/inlineSvg/icon-warning-in-square.svg'
import SvgStateNotifications from '../../../../assets/inlineSvg/icon-layers-three-02.svg'
import SvgAttestation from '../../../../assets/inlineSvg/icon-workflow-attestation.svg'
import SvgFinalApproval from '../../../../assets/inlineSvg/icon-workflow-final-approval.svg'
import SvgFinalReport from '../../../../assets/inlineSvg/icon-workflow-report.svg'
import SvgNotifyOnScan from '../../../../assets/inlineSvg/icon-notify-on-scan-workflow.svg'

import * as uuid from 'uuid'
import React from 'react'
import { FormattedMessage } from 'react-intl'
/*
  use jsconfig...
  todo ....
  // order index for the block -
*/

// ...

// TODO: check id with BE
export const automationBlocksPolicy: AutomationBlock[] = [
  {
    id: 'rule-set-management',
    title: <FormattedMessage id="workflows.block.ruleSet.title" />,
    description: <FormattedMessage id="workflows.block.ruleSet.description" />,
    iconColor: '#5B8DEF',
    icon: <SvgRuleSets />,
    type: WorkflowFlowTypes.RULE_SET
  },
  {
    id: 'alert-assignment',
    title: <FormattedMessage id="workflows.block.alert.title" />,
    description: <FormattedMessage id="workflows.block.alert.description" />,
    iconColor: '#F87171',
    icon: <SvgAlertAssignment />,
    type: WorkflowFlowTypes.ALERT
  },
  {
    id: 'state-notifications',
    title: <FormattedMessage id="workflows.block.state.title" />,
    description: <FormattedMessage id="workflows.block.state.description" />,
    iconColor: '#14B8A6',
    icon: <SvgStateNotifications />,
    type: WorkflowFlowTypes.STATE_NOTIFICATION
  },
  {
    id: 'actions',
    title: <FormattedMessage id="workflows.block.actions.title" />,
    description: <FormattedMessage id="workflows.block.actions.description" />,
    iconColor: '#EC4899',
    icon: <SvgActions />,
    type: WorkflowFlowTypes.ACTION
  }
]

export const automationBlocksUAR: AutomationBlock[] = [
  {
    id: 'scan-complete-notify',
    title: <FormattedMessage id="workflows.block.scan.title" />,
    description: <FormattedMessage id="workflows.block.scan.description" />,
    iconColor: '#5B8DEF',
    icon: <SvgNotifyOnScan />,
    type: WorkflowFlowTypes.UAR_SCAN_COMPLETE_NOTIFICATION
  },

  {
    id: 'uar-attestation',
    title: <FormattedMessage id="workflows.block.attestation.title" />,
    description: <FormattedMessage id="workflows.block.attestation.description" />,
    iconColor: '#723DFD',
    icon: <SvgAttestation />,
    type: WorkflowFlowTypes.UAR_ATTESTATION
  },
  {
    id: 'uar-state-approval',
    title: <FormattedMessage id="workflows.block.finalReview.title" />,
    description: <FormattedMessage id="workflows.block.finalReview.description" />,
    iconColor: '#6BB700',
    icon: <SvgFinalApproval />,
    type: WorkflowFlowTypes.UAR_STATE_APPROVAL
  },
  {
    id: 'report-gen',
    title: <FormattedMessage id="workflows.block.report.title" />,
    description: <FormattedMessage id="workflows.block.report.description" />,
    iconColor: '#00A198',
    icon: <SvgFinalReport />,
    type: WorkflowFlowTypes.UAR_REPORT_GENERATION
  }
]

const stateColorMap: Record<string, TagColor> = {
  [WorkflowNotificationStates.OPEN]: 'information',
  [WorkflowNotificationStatesLable.OPEN]: 'information',
  [WorkflowNotificationStates.DETECTION_CONFIRMED]: 'information',
  [WorkflowNotificationStatesLable.DETECTION_CONFIRMED]: 'information',
  [WorkflowNotificationStates.REQUESTED]: 'information',
  [WorkflowNotificationStatesLable.REQUESTED]: 'information',
  [WorkflowNotificationStates.IN_PROGRESS]: 'lavender',
  [WorkflowNotificationStatesLable.IN_PROGRESS]: 'lavender',
  [WorkflowNotificationStates.IN_REVIEW]: 'lavender',
  [WorkflowNotificationStatesLable.IN_REVIEW]: 'lavender',
  [WorkflowNotificationStates.REVIEW_COMPLETED]: 'success',
  [WorkflowNotificationStatesLable.REVIEW_COMPLETED]: 'success',
  [WorkflowNotificationStates.APPROVED]: 'success',
  [WorkflowNotificationStatesLable.APPROVED]: 'success',
  [WorkflowNotificationStates.ACCESS_REVOKED]: 'success',
  [WorkflowNotificationStatesLable.ACCESS_REVOKED]: 'success',
  [WorkflowNotificationStates.REVIEWED]: 'success',
  [WorkflowNotificationStatesLable.REVIEWED]: 'success',
  [WorkflowNotificationStates.GRANTED]: 'success',
  [WorkflowNotificationStatesLable.GRANTED]: 'success',
  [WorkflowNotificationStates.ON_HOLD]: 'error',
  [WorkflowNotificationStatesLable.ON_HOLD]: 'error',
  [WorkflowNotificationStates.REJECTED]: 'error',
  [WorkflowNotificationStatesLable.REJECTED]: 'error',
  [WorkflowNotificationStates.DECLINED]: 'error',
  [WorkflowNotificationStatesLable.DECLINED]: 'error',
  [WorkflowNotificationStates.ACCESS_REVOKED_FAILED]: 'error',
  [WorkflowNotificationStatesLable.ACCESS_REVOKED_FAILED]: 'error',
  [WorkflowNotificationStates.FLAGGED]: 'error',
  [WorkflowNotificationStatesLable.FLAGGED]: 'error',
  [WorkflowNotificationStates.AWAITING_APPROVAL]: 'caution',
  [WorkflowNotificationStatesLable.AWAITING_APPROVAL]: 'caution',
  [WorkflowNotificationStatesLable.PARTIALLY_GRANTED]: 'success',
  [WorkflowNotificationStates.DENIED]: 'error'
}

export const getTagColor = (
  state: WorkflowNotificationStates | WorkflowNotificationStatesLable
): TagColor => {
  return stateColorMap[state] ?? 'information'
}

export const convertBlocksToWorkflowFormData = (blocks: any[]): WorkflowFormData => {
  const policyUpsertBlock = blocks.find(
    (b) => b.type === WorkflowBlockType.POLICY_UPSERT_NOTIFICATION
  )
  const alertUpsertBlock = blocks.find((b) => b.type === WorkflowBlockType.POLICY_ALERT_ASSIGNMENT)
  const stateNotificationBlock = blocks.find(
    (b) => b.type === WorkflowBlockType.POLICY_STATE_NOTIFICATION
  )
  const stateApprovalBlock = blocks.find((b) => b.type === WorkflowBlockType.POLICY_STATE_APPROVAL)

  const actionBlock = blocks.find(
    (b) => b.type === WorkflowBlockType.POLICY_ACTION_NOTIFICATION_AND_APPROVAL
  )

  // Build WorkflowFormData
  const formData = {} as WorkflowFormData

  if (policyUpsertBlock) {
    formData[WorkflowFlowTypes.RULE_SET] = {
      id: policyUpsertBlock?.config?.id || uuid.v4(),
      isEnabled: policyUpsertBlock?.config?.enabled || false,
      recipients: policyUpsertBlock?.config?.recipientGroups || [],
      additionalNotificationRecipients: policyUpsertBlock?.config?.additionalRecipients || []
    }
  }

  if (alertUpsertBlock) {
    formData[WorkflowFlowTypes.ALERT] = {
      id: alertUpsertBlock?.config?.id || uuid.v4(),
      isEnabled: alertUpsertBlock?.config?.enabled || false,
      recipients: alertUpsertBlock?.config?.assignmentGroup || [],
      additionalNotificationRecipients: alertUpsertBlock?.config?.additionalRecipients || []
    }
  }

  if (stateNotificationBlock) {
    if (!formData[WorkflowFlowTypes.STATE_NOTIFICATION]) {
      formData[WorkflowFlowTypes.STATE_NOTIFICATION] = {} as WorkflowStateNotificationsFormData
    }
    formData[WorkflowFlowTypes.STATE_NOTIFICATION][
      WorkflowStateNotificationTypes.STATE_NOTIFICATION
    ] = {
      id: stateNotificationBlock?.config?.id || uuid.v4(),
      recipients: stateNotificationBlock?.config?.recipientGroups || [],
      additionalNotificationRecipients: stateNotificationBlock?.config?.additionalRecipients || [],
      states: stateNotificationBlock?.config?.states || []
    }
    formData[WorkflowFlowTypes.STATE_NOTIFICATION].cronExpression =
      stateNotificationBlock?.config?.cronExpression || WORKFLOW_DEFAULT_CRON
  }

  if (stateApprovalBlock) {
    if (!formData[WorkflowFlowTypes.STATE_NOTIFICATION]) {
      formData[WorkflowFlowTypes.STATE_NOTIFICATION] = {} as WorkflowStateNotificationsFormData
    }
    formData[WorkflowFlowTypes.STATE_NOTIFICATION][
      WorkflowStateNotificationTypes.STATE_APPROVALS
    ] = {
      id: stateApprovalBlock?.config?.id || uuid.v4(),
      recipients: stateApprovalBlock?.config?.approverGroups || [],
      additionalNotificationRecipients: stateApprovalBlock?.config?.additionalApprovers || [],
      states: stateApprovalBlock?.config?.states || []
    }
    formData[WorkflowFlowTypes.STATE_NOTIFICATION].cronExpression =
      stateApprovalBlock?.config?.cronExpression || WORKFLOW_DEFAULT_CRON
  }

  if (actionBlock) {
    formData[WorkflowFlowTypes.ACTION] = {
      id: actionBlock?.config?.id || uuid.v4(),
      cronExpression: actionBlock?.config?.cronExpression || WORKFLOW_DEFAULT_CRON,
      actions:
        actionBlock?.config?.configs?.map((config) => ({
          id: config?.id || uuid.v4(),
          actionType: config.actionType,
          notificationsEnabled: config.notificationsEnabled || false,
          notificationRecipientGroups: config.notificationRecipientGroups || [],
          additionalNotificationRecipients: config.additionalNotificationRecipients || [],
          approvalEnabled: config.approvalEnabled || false,
          approverGroups: config.approverGroups || [],
          additionalApproverRecipients: config.additionalApprovers || []
        })) || []
    }
  }

  return formData
}

export const convertBlocksToUARWorkflowFormData = (blocks: any[]): WorkflowUARFormData => {
  const uarAttestationBlock = blocks.find((b) => b.type === WorkflowBlockType.UAR_ATTESTATION)
  const uarStateApprovalBlock = blocks.find((b) => b.type === WorkflowBlockType.UAR_STATE_APPROVAL)
  const uarReportGenerationBlock = blocks.find(
    (b) => b.type === WorkflowBlockType.UAR_REPORT_GENERATION
  )
  const uarScanCompleteNotificationBlock = blocks.find(
    (b) => b.type === WorkflowBlockType.UAR_SCAN_COMPLETE_NOTIFICATION
  )

  const formData = {} as WorkflowUARFormData

  if (uarScanCompleteNotificationBlock) {
    formData[WorkflowFlowTypes.UAR_SCAN_COMPLETE_NOTIFICATION] = {
      id: uarScanCompleteNotificationBlock?.config?.id || uuid.v4(),
      enabled: uarScanCompleteNotificationBlock?.config?.enabled || false,
      recipientGroups: uarScanCompleteNotificationBlock?.config?.recipientGroups || [],
      additionalRecipients: uarScanCompleteNotificationBlock?.config?.additionalRecipients || []
    }
  }

  if (uarAttestationBlock) {
    formData[WorkflowFlowTypes.UAR_ATTESTATION] = {
      id: uarAttestationBlock?.config?.id || uuid.v4(),
      attestorType: uarAttestationBlock?.config?.attestorType || WorkflowAttestationTypes.SELF,
      designatedReviewers: uarAttestationBlock?.config?.designatedReviewers || []
    }
  }

  if (uarStateApprovalBlock) {
    formData[WorkflowFlowTypes.UAR_STATE_APPROVAL] = {
      id: uarStateApprovalBlock?.config?.id || uuid.v4(),
      enabled: uarStateApprovalBlock?.config?.enabled || false,
      approverGroups: uarStateApprovalBlock?.config?.approverGroups || [],
      additionalApprovers: uarStateApprovalBlock?.config?.additionalApprovers || [],
      states: uarStateApprovalBlock?.config?.states || []
    }
  }

  if (uarReportGenerationBlock) {
    formData[WorkflowFlowTypes.UAR_REPORT_GENERATION] = {
      id: uarReportGenerationBlock?.config?.id || uuid.v4(),
      enabled: uarReportGenerationBlock?.config?.enabled || false,
      recipientGroups: uarReportGenerationBlock?.config?.recipientGroups || [],
      additionalRecipients: uarReportGenerationBlock?.config?.additionalRecipients || []
    }
  }

  return formData
}

export const WORKFLOW_UAR_STATES = [
  WorkflowNotificationStates.REVIEWED,
  WorkflowNotificationStates.UNREVIEWED,
  WorkflowNotificationStates.FLAGGED,
  WorkflowNotificationStates.REVOKE_IN_PROGRESS,
  WorkflowNotificationStates.ACCESS_REVOKED_BY_SYSTEM,
  WorkflowNotificationStates.ACCESS_REVOKED_BY_USER,
  WorkflowNotificationStates.APPROVED,
  WorkflowNotificationStates.DENIED
]

export const WORKFLOW_TYPE = {
  UAR: 'UAR',
  POLICY: 'POLICY'
}
